module.exports = __webpack_public_path__ + "static/media/bars-icon.71b2b5c2.svg";